import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/2c7f9303/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p><em parentName="p">{`Removing`}</em>{` is an action that moves information from one location to another. Removal can be both destructive and non-destructive. `}<em parentName="p">{`Deletion`}</em>{` is the most common type of removal and is destructive.`}</p>
    </PageDescription>
    <h4 {...{
      "id": "status"
    }}>{`Status:`}</h4>
    <p><a parentName="p" {...{
        "href": "/experimental/overview"
      }}>{`Experimental`}</a></p>
    <h4 {...{
      "id": "maintainers"
    }}>{`Maintainers:`}</h4>
    <p><a parentName="p" {...{
        "href": "https://github.com/vikkipaterson"
      }}>{`Vikki Paterson`}</a></p>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">High-impact deletion</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Medium-impact deletion</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Low-impact deletion</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Medium-impact removal</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Low-impact removal</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Anatomy</AnchorLink>
    </AnchorLinks>
    <h3 {...{
      "id": "delete--remove-variations"
    }}>{`Delete / Remove variations`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Action`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Variation`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Delete`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`High impact`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Action can’t be reversed and causes significant loss. The user types the resource name into the modal to confim deletion.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Medium impact`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Action can’t be reversed and causes some loss. The user sees a modal and confirms the consequence of deletion.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Low impact`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Action is reversible or very low impact. A confirmation modal may not be required.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Remove`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Medium impact`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Action can’t be reversed and causes some loss. The user sees a modal and confirms the consequence of removal.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Low impact`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Action is reversible or very low impact. A confirmation modal may not be required.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "high-impact-deletion"
    }}>{`High-impact deletion`}</h2>
    <p>{`A high-impact deletion cannot be reversed. The action would result in a significant loss for a user if done accidentally.`}</p>
    <p>{`When deleting is high-impact, a confirmation dialog should be presented to the user which displays:`}</p>
    <ul>
      <li parentName="ul">{`The name of the resource`}</li>
      <li parentName="ul">{`Consequences of the deletion`}</li>
      <li parentName="ul">{`This action cannot be undone.`}</li>
      <li parentName="ul">{`An editable text field for the name of the resource to be entered`}</li>
    </ul>
    <p>{`For high-impact scenarios, a user should confirm the action by manually entering the name of the resource. The ‘Delete’ button is enabled when the text entered perfectly matches the resource name.`}</p>
    <p>{`Optionally a `}<a parentName="p" {...{
        "href": "#done-modal"
      }}>{`Done modal`}</a>{`, `}<a parentName="p" {...{
        "href": "#requested-modal"
      }}>{`Requested modal`}</a>{` or `}<a parentName="p" {...{
        "href": "#notification"
      }}>{`Notification`}</a>{` can be used to confirm the action (or a combination of one modal and a notification).`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.733695652173914%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABOElEQVQoz42T3aqCQBSFu+8mewSfwJcSxduuez7fQPIHJMwyf1JLBaFa56yBEcsKBz72jM6svfZsXeB/PJ9PyPjO3CH3LsZi3zY+Ho8hyvmnxIyL8YPL5YI4jnE+n5EkCfI8x+12Q9u2aJpGRMJn5Hq9oqqq74LH4xGO48D3fbiuK4SZpCgKAROQuq4HQcavgnRHoSAIBBTe7XZiTsd8T+hKCtL5RFAuuKEsywEe5AHSdd2kZPJTkKWkaYosy0RkebJkivd9P4GJ2KhB8FeHx0M6fYeOPzpkpu12C8uyYJomDMMQUdd1bDYbcZe8xyiKcDgcBJyfTqdXh3LBcjVNw3q9xmq1EiiKguVyCVVVYds29vs9PM8TzSKch2GI+/0+dUhhdpOfDTstkV1maZ/ukLyUPPcO5/56f000g9dFzJdzAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "The user enters the resource name in order to confirm deletion.",
            "title": "The user enters the resource name in order to confirm deletion.",
            "src": "/static/94e3e3991cb5ce4152271245cad4f4a7/c801a/2.png",
            "srcSet": ["/static/94e3e3991cb5ce4152271245cad4f4a7/1a057/2.png 288w", "/static/94e3e3991cb5ce4152271245cad4f4a7/8418d/2.png 576w", "/static/94e3e3991cb5ce4152271245cad4f4a7/c801a/2.png 1152w", "/static/94e3e3991cb5ce4152271245cad4f4a7/7d33b/2.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  {' '}
  The user needs to enter the resource name in order to confirm deletion.
        </Caption>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.733695652173914%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABZElEQVQoz5WTzU7CQBRGWbpou1EXapSFictufSgTGjRGXOhCFj6ZL0AoTKW6IVQgtPxNG4yln3MvDlQMBCc5ue309szXTluAGlmWQdd1dh26t5CXbWrcBd1byE9EUYQgCNDv99HtdjEYDDCdThHH8S+klAxdG41Gm4Ukc10XrVYLnueh1+vxImEYMrQAMR6PWTaZTLhuFHY6HRaR0Pd9rkIIPqbEtCD1UCotpKR/hPqEGobDId9AlaAb1x9bzxFbhSSiFATJqDlJEmam+MxVTaJ65vP5Srhth/MjUUhFnEP+zGcLCddlQkpRrVZRLpfhOA5KpRJzpagoxN0DPiqPaF9XFtzco+3cInh6RirjVUIdl3bOtm1YlgXTNGEYBizFnqJomHg5Psf7yQWa+6fwDs7gHRYhrCO82ZdIw2ghVK5lwjRNeUdrtRp/Opq6QihkvYEZ0RAr3CZmrz6yr/T/73DXX+8bCUJyLzbDanoAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "When the resource name is entered the Delete button is enabled.",
            "title": "When the resource name is entered the Delete button is enabled.",
            "src": "/static/64648892df210451d60afc6bb54511e4/c801a/3.png",
            "srcSet": ["/static/64648892df210451d60afc6bb54511e4/1a057/3.png 288w", "/static/64648892df210451d60afc6bb54511e4/8418d/3.png 576w", "/static/64648892df210451d60afc6bb54511e4/c801a/3.png 1152w", "/static/64648892df210451d60afc6bb54511e4/7d33b/3.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  {' '}
  When the resource name is entered the Delete button is enabled.
        </Caption>
      </Column>
    </Row>
    <h2 {...{
      "id": "medium-impact-deletion"
    }}>{`Medium-impact deletion`}</h2>
    <p>{`A medium-impact deletion is one that cannot be reversed, but would not be catastrophic if done accidentally. When deleting is medium-impact, a confirmation dialog should be presented to the user which displays:`}</p>
    <ul>
      <li parentName="ul">{`The name of the resource`}</li>
      <li parentName="ul">{`Consequences of the deletion`}</li>
      <li parentName="ul">{`The action cannot be undone.`}</li>
    </ul>
    <p>{`Optionally an `}<a parentName="p" {...{
        "href": "#optional-passive-modal"
      }}>{`Optional passive modal`}</a>{` or `}<a parentName="p" {...{
        "href": "#notification"
      }}>{`Notification`}</a>{` can be used to confirm the action (or a combination of one modal and a notification).`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "53.66847826086957%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABZUlEQVQoz6WS3UoCQRiG96TQQJA6S4LOuwUvJyQ0UojqCryOILqVotPWHXdBUMLcTWN33T/d/7eZsTGjrQP74OEbPvZ7eJkdKc9zMFiJ8zaIfQmfJYbbltiXNu1hGCIIAiwWCyyXS/i+vz4XIb5PkuQr4Wbk2WwGVVUxHA6haRoMw4DneXyJdYHrunAch3fTNLm4UKjrOhRF4bJ+v4/BYMDlrL+Ox5yX0Qjv0yl8KnOp1KPEUVQsZEls28Z8PudYlsVhMy8K4dBFh6Zx4wh+EnO8OEacZd+FrDI6ZElkWQYhhCdlndDeo7z1FDgUWyGwewyFd+tZRmhaP4Xskuv1OiqVCsrlMkqlEmePIu3u4u6ghsnxCUj1ECqnBm3/CGSnCvv2fiWkP2ctjGn0breLRqOBVquFZrPJOaecUh4vLmF1bjBpX8EQdK6hn7URPDythGm2eof/fYO/vkN2j2maFpL/xYbjAxC1ImXWoXgIAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a medium impact delete modal",
            "title": "Example of a medium impact delete modal",
            "src": "/static/194e3f245e69d90655331a2f7e8d45f6/c801a/6.png",
            "srcSet": ["/static/194e3f245e69d90655331a2f7e8d45f6/1a057/6.png 288w", "/static/194e3f245e69d90655331a2f7e8d45f6/8418d/6.png 576w", "/static/194e3f245e69d90655331a2f7e8d45f6/c801a/6.png 1152w", "/static/194e3f245e69d90655331a2f7e8d45f6/7d33b/6.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">An example of a standard delete modal</Caption>
      </Column>
    </Row>
    <h2 {...{
      "id": "low-impact-deletion"
    }}>{`Low-impact deletion`}</h2>
    <p>{`Requiring the user to confirm deletion is generally recommended. However, in low impact situations, or when an ‘undo’ option is available, user confirmation may not be required.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "55.75342465753425%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAAA5klEQVQoz52STQrCMBCFewvXLgVdiR7FnbjS07lwJf4ieAP/BUUqWsEKtrXFaJrmGVuUWlolDjwmZOYNH8koiAnO+Ttzz/tUqBYXChIiyfCrpnwzsLMBMp7iNp3jNluAjCZgliVPyBnzs1VvYJ0tYJ0rYpXJY5lKw262gx7XlSek2gF2pw+7NwjU6sI9nf4ndAZDaJWar12pDK1cBVW3QY/4IGlCj1LcLzaIaYI6Dq4iM3H33oAYyq8Dj/oRG1XFXdBcdR3GXoMbXinZgY6gesqnfWZC/lubqOn1Xjy69LKEYVP0nBQPQO5W9OSE4WQAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of delete options in context without warnings for low impact delete actions",
            "title": "Example of delete options in context without warnings for low impact delete actions",
            "src": "/static/eebf37fae5d13eebdfc6117ea672d0c5/00270/LowImpactDelete.png",
            "srcSet": ["/static/eebf37fae5d13eebdfc6117ea672d0c5/1a057/LowImpactDelete.png 288w", "/static/eebf37fae5d13eebdfc6117ea672d0c5/8418d/LowImpactDelete.png 576w", "/static/eebf37fae5d13eebdfc6117ea672d0c5/00270/LowImpactDelete.png 730w"],
            "sizes": "(max-width: 730px) 100vw, 730px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption"> Low impact delete options</Caption>
      </Column>
    </Row>
    <h2 {...{
      "id": "medium-impact-removal"
    }}>{`Medium-impact removal`}</h2>
    <p>{`Removing has a medium impact when the action can’t be reversed, and could have some impact if done accidentally.`}</p>
    <p>{`Text should tell the user the consequences of the removal and that the action cannot be undone.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "53.66847826086957%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABYUlEQVQoz6WSzU7CQBDHe1EhhkjwJnrx7CPwOIYYMEJilCfgOUyMr6LxSmnTJiSEj1AFaYGuhX7/3d1SrKF6wEl+yWQ7+8vMdoQwDMFgEee7EN8XsI74cNeI7wtJu23bWC6XGyzL4qxWq1RYPfvued53h8mWJ5MJVFVFt9tFp9NBv9/HfD4HIYRjmuYWuq5zcapQ0zRIkgRFUbi41+thOBxGDAb4GI9BmGixAEngOk66kI05nU5hGAbvzHVdOLSYXSCODdN18Om5IGt4TmvcIPgpZBHQQzamKIqQZZl3yvI2pUV5b0tYiBJm7SQyjJYIWze2heyRS6UScrkcstksMpkM55DmwsE+Ho+LGJ1fQC6cQjk6gZIvQi2cQd7LY/bwFAnpz9kI2XjNZhPlchnVahWVSoVzTbmkvNzcwqg3MKrd4S2mfg/tqgbr+TUS+kG0h//dwV/3kL2j7/uphH+RcHwBoDwjOLWhaS8AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a medium impact remove modal",
            "title": "Example of a medium impact remove modal",
            "src": "/static/0e3553c5966d9ce052e440a3cc7796c3/c801a/first-view.png",
            "srcSet": ["/static/0e3553c5966d9ce052e440a3cc7796c3/1a057/first-view.png 288w", "/static/0e3553c5966d9ce052e440a3cc7796c3/8418d/first-view.png 576w", "/static/0e3553c5966d9ce052e440a3cc7796c3/c801a/first-view.png 1152w", "/static/0e3553c5966d9ce052e440a3cc7796c3/7d33b/first-view.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  {' '}
  Removal modals should include consequences of removal, and "This action cannot
  be undone" statement.
        </Caption>
      </Column>
    </Row>
    <h2 {...{
      "id": "low-impact-removal"
    }}>{`Low-impact removal`}</h2>
    <p>{`As removing does not destroy an asset, typically user confirmation is not required.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "55.75342465753425%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAAA7ElEQVQoz51SOwrCQBTMYbSwSWHjUewsBAshnRex8RYWVuIHTyC2IialJkFXMCZs/juucdUYEiUZWObB++zsvJWQA8bYm1kcf59ULg8SClDU8C8n/WoIyQXedgd/r8FXtYRj6pZXyMIwYTIcQW00ocktqHUZak0GXW+eNVFUYiD36gGPq7pN57AXK9izZcLR1fr4m6Myf6C43RpPoHf70HsKDu0OTGWA2LpVeLIojiiFx32kp/OTzwRhEFRQKAoN08TRMOByxTaPLULgC38rDXQcB54rtspjpNSV+jbZpteSWPbTl1WYbsrGRbgDubRXKJoWX1UAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of remove options in context without warnings for low impact remove actions.",
            "title": "Example of remove options in context without warnings for low impact remove actions.",
            "src": "/static/fc0ad9f02e6e111a53a1e38c56a829f2/00270/LowImpactRemove.png",
            "srcSet": ["/static/fc0ad9f02e6e111a53a1e38c56a829f2/1a057/LowImpactRemove.png 288w", "/static/fc0ad9f02e6e111a53a1e38c56a829f2/8418d/LowImpactRemove.png 576w", "/static/fc0ad9f02e6e111a53a1e38c56a829f2/00270/LowImpactRemove.png 730w"],
            "sizes": "(max-width: 730px) 100vw, 730px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption"> Example low impact remove options</Caption>
      </Column>
    </Row>
    <h2 {...{
      "id": "anatomy"
    }}>{`Anatomy`}</h2>
    <h3 {...{
      "id": "optional-passive-modal"
    }}>{`Optional passive modal`}</h3>
    <p>{`In high or medium impact flows, an optional passive modal can be used to signify the state at the end of a remove or delete action.
Some deletion or removal actions don’t happen immediately, in these situations it’s recommended to inform the user through the optional passive modal.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.82191780821917%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAAx0lEQVQoz62S2QqEMAxF/f/fcyn2yRUUKeLy4H6HBCJ1ZhwGbOGQpLQ3l6YeHC/vOA5OKD5BNDxb7MmS+xeH8zxjmiaG8nVdsW3bCdXLslygcxeHtruqqpAkCcqyRJZlXNd1jaZpzjiOI/q+Z7quQ9u22Pf9u2Ce5wjDEFprBEHAeRRFHH3fh1KKmwzDwJAoNbgVJGdxHCNNU3ZIUF4UBTeTPXL2U1AKYww7oINyweZ9T4RvBeWhZTD/8DEUe+TOv42Tj+1a8AUNUKrU+W1a4QAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a delete successful modal",
            "title": "Example of a delete successful modal",
            "src": "/static/730a9e351e7f814753698ebe7a0eb75b/00270/Requested.png",
            "srcSet": ["/static/730a9e351e7f814753698ebe7a0eb75b/1a057/Requested.png 288w", "/static/730a9e351e7f814753698ebe7a0eb75b/8418d/Requested.png 576w", "/static/730a9e351e7f814753698ebe7a0eb75b/00270/Requested.png 730w"],
            "sizes": "(max-width: 730px) 100vw, 730px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  {' '}
  Use a success modal to show that a delete request has been made / is in
  progress.
        </Caption>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.82191780821917%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAAsElEQVQoz62SywqFMAxE/f8/rMWV1CeKVl2VOpcpBBStyLWBIU1JTmaRDIkj2/c9PJi/SBiZPGLQtyG9J4dvhrz3J10cHj+6rkNZlqjrGlVVwRiDvu8xjiOGYYC1Ftu2YVmWoHmeMU1TAN8CCVNKoSiKkLXWyPM8ZNZcRDhBBHIBcxRIRxxs2xZN04R8lDinKwGu63oFSsEGbmfTkwQWdSiFc+4vRc/mS9yeTbLDThk/35+t+yCJMFMAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a remove successful modal",
            "title": "Example of a remove successful modal",
            "src": "/static/3da478e89555d7a2758668276bd4ac91/00270/DoneMedium.png",
            "srcSet": ["/static/3da478e89555d7a2758668276bd4ac91/1a057/DoneMedium.png 288w", "/static/3da478e89555d7a2758668276bd4ac91/8418d/DoneMedium.png 576w", "/static/3da478e89555d7a2758668276bd4ac91/00270/DoneMedium.png 730w"],
            "sizes": "(max-width: 730px) 100vw, 730px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption"> Use a success modal to show that removing is complete.</Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "notification"
    }}>{`Notification`}</h3>
    <p>{`An optional notification can be used to confirm a delete or remove action has completed. This is useful when the action takes more than a few moments.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "37.36413043478261%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsSAAALEgHS3X78AAAAwElEQVQoz5WRDYuCUBBF+/9/qiIo+xayNSiVCtbW1dyKNH2+d1LajUUM7cIMw3A5zEeLkpRSv8WjLkfRR5W8/9SqglUZ/yRzmizyC28lMMlSesGcobdA2+n0tzO0vc5gO8c4WziJi1TyuUUtMBY39OuasWfQsYa0Nxpde8TUN1lGDo5wyQpg0wkjEbOIbIyrzfRoMgtXTIIPjLxnZjss8fkeMJUCLw35Fj8cbgGH2MfN4ys54ssTobw0u2HdQ5p47xqaIgH8sXt7AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a successful delete notification",
            "title": "Example of a successful delete notification",
            "src": "/static/6ec5f0cc990e4db7ea03993fd77fdb9d/c801a/7_updated.png",
            "srcSet": ["/static/6ec5f0cc990e4db7ea03993fd77fdb9d/1a057/7_updated.png 288w", "/static/6ec5f0cc990e4db7ea03993fd77fdb9d/8418d/7_updated.png 576w", "/static/6ec5f0cc990e4db7ea03993fd77fdb9d/c801a/7_updated.png 1152w", "/static/6ec5f0cc990e4db7ea03993fd77fdb9d/7d33b/7_updated.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  {' '}
  An optional notification can be used to confirm the delete or remove action
  with medium or high impact actions.
        </Caption>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      